import { styled } from '@mui/material';

export const NoParticipantsWrapper = styled('div')({
  padding: '0.5rem 1rem',
});

export const ParticipantsRoot = styled('div')({
  height: '100%',
  overflow: 'auto',
  padding: '0.5rem 1rem',
});
